import { Base } from '../base-component';
import './content-display-with-no-icons-and-image.component.scss';

export class ContentDisplayWithNoIconsAndImage extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/content-display-with-no-icons-and-image/content-display-with-no-icons-and-image.component.ts